/****************************************************
 * Module Name:  addKapanPacketModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, Tooltip } from "@mui/material";
import logo from '../../images/pansuriya.jpg';
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import EditIcon from '@mui/icons-material/Edit';
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Utility from "../../utility/utility";

const AddKapanPacketModal = ({
    show,
    handleSave,
    handleClose,
}) => {
    const { apiRef, handleCellClick } = Utility.useSingleClickEdit();
    const [resultData, setResultData] = useState([]);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        setResultData([{ kapanid: "", packetid: "", id: 1 }]);
        setIndex((prev) => prev + 1);
    }, [])

    const handleProcessRowUpdateError = (error) => {
        // console.error(error);
    };

    const getChangedFields = (newRow, oldRow) => {
        const changedFields = [];
        Object.keys(newRow).forEach(field => {
            if (newRow[field] !== oldRow[field]) {
                changedFields.push({
                    id: newRow.id,
                    field: field,
                    value: newRow[field]
                });
            }
        });

        return changedFields;
    };

    const processRowUpdate = (newR, oldRow) => {
        const changedFeilds = getChangedFields(newR, oldRow);

        if (changedFeilds.length > 0) {
            const { id, field, value } = changedFeilds[0];
            let newRecord;
            let updatedRow = resultData.map(iRow => {

                if (iRow.id === id) {
                    if (field === "kapanid" && typeof value === "number") {
                        const kapanid = value;

                        const newRow = { ...iRow, [field]: kapanid };
                        newRecord = newRow;

                        return newRow;
                    }
                    else if (field === "packetid") {
                        const packetid = value;

                        const newRow = { ...iRow, [field]: packetid };
                        newRecord = newRow;
                        return newRow;
                    }
                }
                return iRow;
            });
            setResultData(updatedRow);
            return newRecord;
        } else {
            // No changes detected, return the newRow to trigger exit edit mode
            return { ...newR };
        }
    }

    const deletRecord = (index) => {
        let newData = resultData.filter((iData) => index !== iData.id);
        if (index >= 0)
            setIndex((prev) => prev - 1)
        setResultData(newData);
    }

    const columns = [
        {
            field: "kapanid",
            headerName: "KAPANID",
            headerAlign: "center",
            align: 'center',
            type: "number",
            width: 250,
            editable: (params) => params.row.editable,
            valueFormatter: (params) => params.value,
            renderCell: (params) => (
                <div style={{ display: 'flex', }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {params.value}
                    </span>
                    <EditIcon style={{ marginLeft: 180, marginBottom: 3, fontSize: '1rem' }} />
                </div>
            ),
            cellClassName: (params) => 'lavenderCell',
        },
        {
            field: "packetid",
            headerName: "PACKETID",
            headerAlign: "center",
            align: 'center',
            width: 250,
            valueFormatter: (params) => params.value,
            editable: (params) => params.row.editable,
            renderCell: (params) => (
                <div style={{ display: 'flex', }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {params.value}
                    </span>
                    <EditIcon style={{ marginLeft: 180, marginBottom: 3, fontSize: '1rem' }} />
                </div>
            ),
            cellClassName: (params) => 'lavenderCell',
        },
        {
            field: "delete",
            headerName: "",
            headerAlign: "center",
            align: 'center',
            width: 25,
            renderCell: (params) => (
                <DeleteForeverIcon color={"error"} onClick={(e) => deletRecord(params.id)} />
            ),
        },
    ];

    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                size="lg"
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Add Kapan ID & Packet ID
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box px={1} pt={1} sx={{
                        position: "relative",
                    }}>

                        <Box sx={{ height: 400, width: '100%' }}>
                            <DataGridPro
                                rows={resultData}
                                columns={columns}
                                disableRowSelectionOnClick={true}
                                density="compact"
                                initialState={{
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                getRowId={(row) => row.id}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: () => null,
                                }}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        fontSize: '16px',
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "4px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },

                                    "& .lavenderCell": {
                                        color: "#080808",
                                        backgroundColor: "#D8BFD8",
                                    },
                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                processRowUpdate={(newR, oldRow) => processRowUpdate(newR, oldRow)}
                                onProcessRowUpdateError={handleProcessRowUpdateError}
                                apiRef={apiRef}
                                onCellClick={handleCellClick}
                                editMode="cell"
                            />
                        </Box>
                        <Box sx={{
                            position: "absolute",
                            top: "0.4rem",
                            right: "1rem",
                            display: "flex",
                            alignItems: "center",
                        }}>

                            <Box display={"flex"} alignItems={"center"}
                                sx={{
                                    "& .MuiFormControlLabel-root": {
                                        margin: 0
                                    },
                                    "& .MuiSwitch-root": {
                                        width: "38px",
                                        height: "22px"
                                    },
                                    "& .MuiSwitch-thumb": {
                                        width: "18px !important",
                                        height: "18px !important"
                                    },
                                    margin: "8px"

                                }}
                            >
                                <Tooltip title="Add Data">
                                    <Button
                                        color="info"
                                        variant="outlined"
                                        size="small"
                                        sx={{ ml: "5px" }}
                                        onClick={() => {
                                            setResultData((prevdata) => {

                                                return [
                                                    ...prevdata,
                                                    { kapanid: "", packetid: "", id: index + 1 }
                                                ]
                                            })
                                            if (index >= 0)
                                                setIndex((prev) => prev + 1)
                                        }}
                                        startIcon={<AddBoxOutlinedIcon size="large" />}
                                    >
                                        ADD RECORD
                                    </Button>
                                </Tooltip>
                            </Box>

                        </Box>
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" color="success" onClick={() => handleSave(resultData)}>
                        save
                    </Button>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddKapanPacketModal;
